import moment from "../../../../vendor/assets/javascripts/limitless_kit/plugins/ui/moment/moment.min";

globalThis.moment = moment;
